import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { Loading } from '../components/Loading';
import { EmptyState } from '../components/EmptyState';

const categoryEmojis = {
  mercado: '🛒', farmacia: '💊', padaria: '🥖', restaurante: '🍽️',
  servicos: '🔧', evento: '🎉', publico: '🏛️'
};

export function FavoritesPage() {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFavorites = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get('/favorites');
      setFavorites(data.data || []);
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Erro ao carregar favoritos');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchFavorites(); }, [fetchFavorites]);

  const removeFavorite = async (businessId) => {
    try {
      await api.delete(`/favorites/${businessId}`);
      setFavorites(prev => prev.filter(f => f.id !== businessId));
    } catch {
      // mantém na lista; sem feedback destrutivo
    }
  };

  return (
    <div className="nc-page">
      <div className="nc-pagehead">
        <div className="nc-row">
          <button onClick={() => navigate('/perfil')} aria-label="Voltar" className="nc-iconbtn">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="nc-page-title">Meus favoritos</h1>
        </div>
      </div>

      <div className="nc-container" style={{ paddingTop: 16, paddingBottom: 16 }}>
        {loading ? <Loading message="Carregando favoritos..." /> : error ? (
          <div role="alert" style={{
            padding: 14, borderRadius: 10, background: 'var(--nc-danger-soft)', border: '1px solid var(--nc-danger-border)',
            color: 'var(--nc-danger-text)', fontSize: 13, marginBottom: 12
          }}>
            {error}
            <button onClick={fetchFavorites} className="nc-btn-primary" style={{ marginTop: 10, width: '100%' }}>Tentar novamente</button>
          </div>
        ) : favorites.length === 0 ? (
          <EmptyState
            icon="⭐"
            title="Nenhum favorito ainda"
            description="Toque no coração em um comércio para salvá-lo aqui."
            action={<button className="nc-btn-primary" onClick={() => navigate('/mapa')}>Explorar comércios</button>}
          />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {favorites.map(f => (
              <div key={f.id} style={{ background: 'var(--nc-surface)', borderRadius: 12, border: '1px solid var(--nc-border)', padding: 12, display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 10, background: 'var(--nc-surface-alt)', overflow: 'hidden',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0
                }}>
                  {f.logo_url ? (
                    <img src={f.logo_url} alt={`Logo de ${f.name}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (categoryEmojis[f.category] || '🏪')}
                </div>
                <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => navigate(`/comercio/${f.id}`)}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--nc-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</div>
                  <div className="nc-hint">
                    {f.city_name}/{f.state} • {f.address}
                  </div>
                  {f.rating > 0 && (
                    <div style={{ fontSize: 12, color: 'var(--nc-warning)', marginTop: 2 }}>{'★'.repeat(Math.floor(f.rating))} ({f.reviews})</div>
                  )}
                </div>
                <button
                  onClick={() => removeFavorite(f.id)}
                  aria-label={`Remover ${f.name} dos favoritos`}
                  style={{
                    background: 'var(--nc-danger-soft)', border: '1px solid var(--nc-danger-border)', color: 'var(--nc-danger)',
                    borderRadius: 10, width: 38, height: 38, display: 'flex', alignItems: 'center',
                    justifyContent: 'center', cursor: 'pointer', flexShrink: 0, fontSize: 16
                  }}
                >
                  ♥
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
